import { Box, Flex } from '@mantine/core';
import { BackButton } from '@/components';
import { DefaultContainer } from '@/containers/DefaultContainer';

type TopBarProps = {
  title: string;
  Component?: JSX.Element | null;
  border?: boolean;
};

export const TopBar = ({ title, Component, border = true }: TopBarProps): JSX.Element => (
  <Box
    className="top-bar"
    style={{
      borderBottom: border ? '1px solid var(--border-color)' : '',
    }}
  >
    <DefaultContainer>
      <Flex justify="space-between" align="center">
        <Flex align="center">
          <BackButton title={title} />
        </Flex>
        {Component && Component}
      </Flex>
    </DefaultContainer>
  </Box>
);
